import { createAction, props } from '@ngrx/store';
import { Category } from '@/model/category';
import { OfferWithImage } from '@/model/offer-with-image';

export const loadTrendingData = createAction(
  '[Trending Categories] Load Trending Data',
);
export const loadTrendingDataSuccess = createAction(
  '[Trending Categories] Load Trending Data Success',
  props<{ offers: OfferWithImage[]; categories: Category[] }>(),
);
export const loadTrendingDataFailure = createAction(
  '[Trending Categories] Load Trending Data Failure',
  props<{ error: unknown }>(),
);

export const selectCategory = createAction(
  '[Trending Categories] Select Category',
  props<{ categoryId: string }>(),
);

export const applyInitialCategoryFilter = createAction(
  '[Trending Categories] Apply Initial Category Filter',
);

export const resetTrendingCategories = createAction(
  '[Trending Categories] Reset',
);
